<template>
  <div class="Enquiries-Main">
    <div class="left-container" :class="[closeLeftTab ? 'left-tab-close' : '']">
      <div class="arrow-button">
        <img
          :style="{ transform: `${closeLeftTab && !narrowWindow ? `scaleX(-1)` : (!closeLeftTab && !narrowWindow ? `scaleX(1)` : (closeLeftTab && narrowWindow ? `rotate(0deg) scaleX(-1)` : `rotate(0deg) scaleX(1)`))}` }"
          @click="closeLeftTab = !closeLeftTab" src='https://img.icons8.com/material-rounded/96/000000/double-left.png'>
      </div>
      <div class="refresh-icon" v-if="closeLeftTab">
        <Tooltip
          icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png"
          :position="narrowWindow ? 'right' : 'bottom'" :iconSize="30" :yOffset="narrowWindow ? 0 : 30"
          :xOffset="narrowWindow ? -10 : 0" @click.native="refreshClicked">
          <div slot="tooltipText">
            <div>GL Acc #: <span :style="{ color: selectedGLNo ? '' : 'red' }">{{ selectedGLNo.length === 0 ? 'All' :
              selectedGLNo.map((x) => { return x["Acc No"]; }).join(",") }}</span></div>
            <div>Txn Type: <span :style="{ color: selectedTxn ? '' : 'red' }">{{ selectedTxn.length === 0 ? 'All' :
              selectedTxn.map((x) => { return x["Txn Type Desc"]; }).join(",") }}</span></div>
            <div>Debtor: <span :style="{ color: selectedDebtor ? '' : 'red' }">{{ selectedDebtor.length === 0 ? 'All' :
              selectedDebtor.map((x) => { return x["Customer Code"]; }).join(",") }}</span></div>
            <div>Creditor: <span :style="{ color: selectedCreditor ? '' : 'red' }">{{ selectedCreditor.length === 0 ?
              'All' : selectedCreditor.map((x) => { return x["Creditor Code"]; }).join(",") }}</span></div>
            <div>Shpr/Csgn: <span :style="{ color: selectedShpr ? '' : 'red' }">{{ selectedShpr.length === 0 ? 'All' :
              selectedShpr.map((x) => { return x["Customer Code"]; }).join(",") }}</span></div>
            <div>Vehicle #: <span :style="{ color: selectedVehicleNo ? '' : 'red' }">{{ selectedVehicleNo.length === 0 ?
              'All' : selectedVehicleNo.map((x) => { return x["Inventory #"]; }).join(",") }}</span></div>
            <div>Job #: <span :style="{ color: filterItems[0] ? '' : 'red' }">{{ filterItems[0].value === '' ? 'All' :
              filterItems[0].value.split("\n").join(",") }}</span></div>
            <div>Batch #: <span :style="{ color: filterItems[1] ? '' : 'red' }">{{ filterItems[1].value === '' ? 'All' :
              filterItems[1].value.split("\n").join(",") }}</span></div>
            <div>Ref #: <span :style="{ color: filterItems[2] ? '' : 'red' }">{{ filterItems[2].value === '' ? 'All' :
              filterItems[2].value.split("\n").join(",") }}</span></div>
            <div>Remarks: <span :style="{ color: filterItems[3] ? '' : 'red' }">{{ filterItems[3].value === '' ? 'All' :
              filterItems[3].value.split("\n").join(",") }}</span></div>
            <div>From: <span :style="{ color: selectedFromDate ? '' : 'red' }">{{ selectedFromDate ? (new
              Date(selectedFromDate)).formatString('yyyy-MM-dd') : 'Not Selected' }}</span></div>
            <div>To: <span :style="{ color: selectedToDate ? '' : 'red' }">{{ selectedToDate ? (new
              Date(selectedToDate)).formatString('yyyy-MM-dd') : 'Not Selected' }}</span></div>
          </div>
        </Tooltip>
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <button @click="refreshClicked">Refresh</button>
        <DateTimePicker :showTime="false" placeholder="From" :isRequired="true" :value.sync="selectedFromDate"
          :errorMessage.sync="errorFromDate"></DateTimePicker>
        <DateTimePicker :showTime="false" placeholder="To" :isRequired="true" :value.sync="selectedToDate"
          :errorMessage.sync="errorToDate"></DateTimePicker>
        <div class="filters">
          <Filters id="filter" title="GL Acc #" :selectedObject.sync="selectedGLNo" :tableData="GLNo" itemKey="Acc No"
            itemDesc="Description">
          </Filters>
          <Filters id="filter" title="Txn Type" :selectedObject.sync="selectedTxn" :tableData="Txn"
            itemKey="Txn Type Desc"> </Filters>
        </div>
        <div class="filters">
          <Filters id="filter" title="Debtor" :selectedObject.sync="selectedDebtor" :tableData="Debtor"
            itemKey="Customer Code" itemDesc="Customer Name"> </Filters>
          <Filters id="filter" title="Creditor" :selectedObject.sync="selectedCreditor" :tableData="Creditor"
            itemKey="Creditor Code" itemDesc="Creditor Name"> </Filters>
        </div>
        <div class="filters">
          <Filters id="filter" title="Shpr/Csgn" :selectedObject.sync="selectedShpr" :tableData="Shpr"
            itemKey="Customer Code" itemDesc="Customer Name"> </Filters>
          <Filters id="filter" title="Vehicle #" :selectedObject.sync="selectedVehicleNo" :tableData="VehicleNo"
            itemKey="Inventory #" itemDesc="Inventory Code"> </Filters>
        </div>
        <div class="filters-free">
          <div v-for="(f, index) in filterItems" :key="index" class="filter-items">
            <div class="filter-title">
              <div>{{ f.title }}</div>
            </div>
            <textarea :title="`Enter the ${f.title}, 1 ${f.title} per line`" v-model="f.value"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="top-container">
        <div class="left-content">
          <div class="filtered-content">
            <div class="filtered-title">From</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredFromDate }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">To</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredToDate }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">GL Acc #</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-GL">{{ filteredGLNo }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Txn Type</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredTxn }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Debtor</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredDebtor }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Creditor</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredCreditor }}</div>
          </div>
        </div>
        <div class="middle-content">
          <div class="filtered-content">
            <div class="filtered-title">Shpr / Csgn</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredShpr }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Vehicle #</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredVehicleNo }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Job #</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredJobNo }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Batch #</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredBatchNo }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Ref #</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredRefNo }}</div>
          </div>
          <div class="filtered-content">
            <div class="filtered-title">Remarks</div>
            <div class="filtered-colon">:</div>
            <div class="filtered-result">{{ filteredRemarks }}</div>
          </div>
        </div>
        <div class="right-content">
          Last Refreshed : {{ lastRefreshed }}
        </div>
      </div>
      <div class="bottom-container">
        <TableBox title="Enquiries" :tableData="tableData" :dataType="tableDataType" :tableFilters="filteredData" :selectedRow.sync="selectedEnquiries" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function () {
    return {
      // set true to close left tab
      closeLeftTab: false,
      // last refresh time on top right
      lastRefreshed: null,
      narrowWindow: false,

      // table data
      tableData: [],
      tableDataType: {
        "#": "number",
        "Fyear": "number",
        "Txn Date": "datetime",
        "Dr": "currency",
        "Cr": "currency",
        "Date Updated": "datetime",
      },
      // to display filtered data in downloaded excel
      filteredData: null,
      selectedEnquiries: [],

      // filters data
      GLNo: [],
      Txn: [],
      Debtor: [],
      Creditor: [],
      Shpr: [],
      VehicleNo: [],

      // selected data
      selectedGLNo: [],
      selectedTxn: [],
      selectedDebtor: [],
      selectedCreditor: [],
      selectedShpr: [],
      selectedVehicleNo: [],
      selectedFromDate: null,
      selectedToDate: null,

      // data for controller
      injectedGLNo: [],
      injectedTxn: [],
      injectedDebtor: [],
      injectedCreditor: [],
      injectedShpr: [],
      injectedVehicleNo: [],
      injectedJobNo: [],
      injectedBatchNo: [],
      injectedRefNo: [],
      injectedRemarks: [],
      injectedFromDate: null,
      injectedToDate: null,

      // error message
      errorFromDate: '',
      errorToDate: '',

      // filtered content
      filteredGLNo: '',
      filteredTxn: '',
      filteredDebtor: '',
      filteredCreditor: '',
      filteredShpr: '',
      filteredVehicleNo: '',
      filteredJobNo: '',
      filteredBatchNo: '',
      filteredRefNo: '',
      filteredRemarks: '',
      filteredFromDate: '',
      filteredToDate: '',

      // filters with free text items
      filterItems: [
        { title: "Job #", value: "" },
        { title: "Batch #", value: "" },
        { title: "Ref #", value: "" },
        { title: "Remarks", value: "" },
      ],
    }
  },
  props: {
  },
  methods: {
    // refresh button
    refreshClicked: async function () {
      // error check on date
      if (this.errorDatePickerCheck()) {
        this.$fullscreenLoading();
        this.$showAlert('error', 'Error in Date Range', 'Please enter a valid From Date and To Date');
        return;
      }

      this.selectedEnquiries = [];

      // clear previous filters
      this.refreshClearFilter();

      this.$fullscreenLoading("Refreshing");
      // get latest refresh datetime 
      this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

      // read items from filters to generate table 
      // GL Acc No
      this.injectedGLNo = (this.selectedGLNo.length > 0 ? this.selectedGLNo.map((x) => { return x["Acc No"]; }).join(",") : null);
      // Txn Type
      this.injectedTxn = (this.selectedTxn.length > 0 ? this.selectedTxn.map((x) => { return x["Txn Type"]; }).join(",") : null);
      // Debtor
      this.injectedDebtor = (this.selectedDebtor.length > 0 ? this.selectedDebtor.map((x) => { return x["Customer Code"]; }).join(",") : null);
      // Creditor
      this.injectedCreditor = (this.selectedCreditor.length > 0 ? this.selectedCreditor.map((x) => { return x["Creditor Code"]; }).join(",") : null);
      // Shpr / Csgn
      this.injectedShpr = (this.selectedShpr.length > 0 ? this.selectedShpr.map((x) => { return x["Customer Code"]; }).join(",") : null);
      // Vehicle #
      this.injectedVehicleNo = (this.selectedVehicleNo.length > 0 ? this.selectedVehicleNo.map((x) => { return x["Inventory #"]; }).join(",") : null);

      // Job #
      this.injectedJobNo = this.filterItems[0].value.split("\n").map(item => item.trim()).filter(item => item !== "").join(",") || null;
      // Batch #
      this.injectedBatchNo = this.filterItems[1].value.split("\n").map(item => item.trim()).filter(item => item !== "").join(",") || null;
      // Ref #
      this.injectedRefNo = this.filterItems[2].value.split("\n").map(item => item.trim()).filter(item => item !== "").join(",") || null;
      // Remarks
      this.injectedRemarks = this.filterItems[3].value.split("\n").map(item => item.trim()).filter(item => item !== "").join(",") || null;

      // Date 
      this.injectedFromDate = (new Date(this.selectedFromDate)).formatString('yyyy-MM-dd');
      this.injectedToDate = (new Date(this.selectedToDate)).formatString('yyyy-MM-dd');

      // get filtered contents 
      this.filteredContent();

      // get table data
      this.tableData = await this.$apiCallV2(`/Enquiries/Enquiries`,
        {
          "starttxndate": this.injectedFromDate,
          "endtxndate": this.injectedToDate,
          "glaccno": this.injectedGLNo,
          "txntype": this.injectedTxn,
          "debtor": this.injectedDebtor,
          "creditor": this.injectedCreditor,
          "shprcsgn": this.injectedShpr,
          "vehicleno": this.injectedVehicleNo,
          "jobno": this.injectedJobNo,
          "batchno": this.injectedBatchNo,
          "refno": this.injectedRefNo,
          "remarks": this.injectedRemarks,
        });

      this.$fullscreenLoading();
    },
    // display filtered contents on top container
    filteredContent: function () {
      this.filteredTxn = this.selectedTxn.length > 0 ? this.selectedTxn.map((x) => { return x["Txn Type Desc"]; }).join(",") : "All";
      this.filteredGLNo = this.selectedGLNo.length > 0 ? this.selectedGLNo.map((x) => { return x["Acc No"]; }).join(",") : "All";
      this.filteredDebtor = this.selectedDebtor.length > 0 ? this.selectedDebtor.map((x) => { return x["Customer Code"]; }).join(",") : "All";
      this.filteredCreditor = this.selectedCreditor.length > 0 ? this.selectedCreditor.map((x) => { return x["Creditor Code"]; }).join(",") : "All";
      this.filteredShpr = this.selectedShpr.length > 0 ? this.selectedShpr.map((x) => { return x["Customer Code"]; }).join(",") : "All";
      this.filteredVehicleNo = this.selectedVehicleNo.length > 0 ? this.selectedVehicleNo.map((x) => { return x["Inventory #"]; }).join(",") : "All";
      this.filteredJobNo = this.injectedJobNo != null && this.injectedJobNo.trim() !== "" ? this.injectedJobNo : "All";
      this.filteredBatchNo = this.injectedBatchNo != null && this.injectedBatchNo.trim() !== "" ? this.injectedBatchNo : "All";
      this.filteredRefNo = this.injectedRefNo != null && this.injectedRefNo.trim() !== "" ? this.injectedRefNo : "All";
      this.filteredRemarks = this.injectedRemarks != null && this.injectedRemarks.trim() !== "" ? this.injectedRemarks : "All";
      this.filteredFromDate = this.injectedFromDate;
      this.filteredToDate = this.injectedToDate;

      this.filteredData = {
        "From": this.filteredFromDate,
        "To": this.filteredToDate,
        "GL Acc #": this.filteredGLNo,
        "Txn Type": this.filteredTxn,
        "Debtor": this.filteredDebtor,
        "Creditor": this.filteredCreditor,
        "Shpr/Csgn": this.filteredShpr,
        "Vehicle #": this.filteredVehicleNo,
        "Job #": this.filteredJobNo,
        "Batch #": this.filteredBatchNo,
        "Ref #": this.filteredRefNo,
        "Remarks": this.filteredRemarks,
      };

    },
    // error check on date 
    errorDatePickerCheck: function () {
      if (this.selectedFromDate == null && this.selectedToDate == null) {
        this.errorFromDate = 'Please Select From Date';
        this.errorToDate = 'Please Select To Date';
        return true;
      }
      else if (this.selectedFromDate == null && this.selectedToDate != null) {
        this.errorFromDate = 'Please Select From Date';
        return true;
      }
      else if (this.selectedFromDate != null && this.selectedToDate == null) {
        this.errorToDate = 'Please Select To Date';
        return true;
      }

      if (this.selectedFromDate != null && this.selectedToDate != null) {
        if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
          this.errorFromDate = 'From Date > To Date';
          this.errorToDate = 'From Date > To Date';
          return true;
        }
      }
      return false;
    },
    // clear previous filtered items before generating new table
    refreshClearFilter: function () {
      this.injectedGLNo = [];
      this.injectedTxn = [];
      this.injectedDebtor = [];
      this.injectedCreditor = [];
      this.injectedShpr = [];
      this.injectedVehicleNo = [];
      this.injectedJobNo = [];
      this.injectedBatchNo = [];
      this.injectedRefNo = [];
      this.injectedRemarks = [];
      this.injectedFromDate = null;
      this.injectedToDate = null;

      this.filteredGLNo = '';
      this.filteredTxn = '';
      this.filteredDebtor = '';
      this.filteredCreditor = '';
      this.filteredShpr = '';
      this.filteredVehicleNo = '';
      this.filteredJobNo = '';
      this.filteredBatchNo = '';
      this.filteredRefNo = '';
      this.filteredRemarks = '';
      this.filteredFromDate = '';
      this.filteredToDate = '';

      this.filteredData = null;
      this.tableData = [];

      this.errorFromDate = '';
      this.errorToDate = '';
    },
  },
  async mounted() {
    // default refresh datetime on mounted
    this.lastRefreshed = (new Date()).formatString('yyyy-MM-dd HH:mm');

    // default from Date and to Date to beginning of the month to end of the month
    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    // load filters data
    this.$fullscreenLoading('Loading Filters');
    this.GLNo = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "glaccount" });
    this.Txn = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "GLTXN" });
    this.Debtor = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "billcust" });
    this.Creditor = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "creditor" });
    this.Shpr = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "customer" });
    this.VehicleNo = await this.$apiCallV2('/Master/GetListMaster', { "masterfile": "vehicle" });
    this.$fullscreenLoading();

  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Enquiries-Main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  .left-container {
    z-index: 111;
    border-radius: 5px;
    max-width: 200px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;

    >.arrow-button {
      width: 100%;
      padding: 7px 4px 10px 0px;
      display: flex;
      justify-content: flex-end;

      >img {
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.5);
          transition: 0.3s ease;
        }
      }
    }

    >.refresh-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 5px;
      cursor: pointer;
    }

    >.left-container-content {
      background-color: white;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      padding-left: 5px;

      >button {
        width: 90%;
        margin-left: 5px;
      }

      >.filters {
        flex-direction: row;
        display: flex;
        width: 190px;

        >#filter {
          height: 85px;
        }
      }

      >.filters-free {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-right: 5px;

        >.filter-items {
          min-width: calc(50% - 10px);
          height: 120px;
          flex-grow: 1;
          margin: 2px;
          font-size: 10px;
          display: flex;
          flex-direction: column;
          position: relative;

          >.filter-title {
            display: flex;
            align-items: center;
            position: absolute;
            height: 15px;
            width: 100%;

            >div {
              flex-grow: 1;
            }
          }

          >textarea {
            position: absolute;
            height: calc(100% - 17px);
            resize: none;
            width: 100%;
            top: 17px;
            border: 1px solid rgb(200, 200, 200);

            &:focus {
              outline: none;
            }
          }
        }
      }
    }
  }

  >.left-tab-close {
    z-index: 111;
    max-width: 40px;
  }

  .right-container {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    >.top-container {
      width: 100%;
      border-radius: 5px;
      min-height: 120px;
      height: auto;
      background-color: white;
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      >.left-content {
        flex: 1;
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;

        >.filtered-content {
          display: flex;

          >.filtered-title {
            min-width: 80px;
            max-width: 80px;
          }

          >.filtered-colon {
            padding-right: 5px;
            padding-left: 5px;
          }

          >.filtered-result {
            height: 20px;
            max-width: 250px;
            margin-right: 10px;
            overflow: hidden;
          }
          >.filtered-GL{
            max-width: 250px;
            margin-right: 10px;
            height: 30px;
            overflow: scroll;
          }
        }
      }

      >.middle-content {
        flex: 1;
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;

        >.filtered-content {
          display: flex;

          >.filtered-title {
            min-width: 80px;
            max-width: 80px;
          }

          >.filtered-colon {
            padding-right: 5px;
            padding-left: 5px;
          }

          >.filtered-result {
            max-width: 250px;
            margin-right: 10px;
            height: 20px;
            overflow: hidden;
          }
        }
      }

      >.right-content {
        flex: 1;
        padding: 5px 5px 0 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 100%;
      }
    }

    >.bottom-container {
      width: 100%;
      height: calc(100% - 125px);
      margin-bottom: 5px;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
    }
  }
}
</style>